(function($){

    $( '.modal' ).on( 'shown.bs.modal', function(){
        if( $( this ).hasClass( 'uninitialized' ) ){
            $( this ).find( '.gallery-slick-slider' ).slick({
                infinite: true,
                dots: false,
                arrows: true,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><i class="fal fa-chevron-left"></i></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><i class="fal fa-chevron-right"></i></button>',
            });
            $( this ).removeClass( 'uninitialized' );
        }
    });

    $( '.modal-content .close' ).on( 'click', function(){
        $( this ).closest( '.modal' ).modal('hide');
    });

    $( '.modal' ).each( function(){
        let $modal  = $( this );
        let trigger = parseInt( $modal.attr( 'data-auto-trigger' ) );
        if( trigger && trigger > 0 ){
            console.log( trigger );
            setTimeout( function(){
                $modal.modal( 'show' );
            }, trigger * 1000 );
        }
    });

})( jQuery );